// 类型声明
declare global {
  interface Window {
    WebViewJavascriptBridge?: any
    WVJBCallbacks?: any[]
  }
}

// 1. 判断平台
const u = navigator?.userAgent?.toLowerCase()
export const isAndroid = u?.includes('android')
// u?.includes('android') &&
// !u?.includes('chrome') &&
// !u?.includes('firefox') &&
// !u?.includes('safari')
export const isIOS =
  /iphone|ipad|ipod/.test(u) &&
  !u?.includes('chrome') &&
  !u?.includes('firefox') &&
  !u?.includes('safari')
// 2. 桥接初始化函数
function iosInit(callback) {
  console.log('桥接初始化函数iosInit>>>>>', window)
  console.log('window?.WebViewJavascriptBridge>>>>>', window?.WebViewJavascriptBridge)
  console.log('window?.WVJBCallbacks>>>>>', window?.WVJBCallbacks)

  if (window?.WebViewJavascriptBridge) {
    callback(window?.WebViewJavascriptBridge)
  } else if (window?.WVJBCallbacks) {
    window?.WVJBCallbacks?.push(callback)
  } else {
    window.WVJBCallbacks = [callback]
    const WVJBIframe = document.createElement('iframe')
    WVJBIframe.style.display = 'none'
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
    document.documentElement.appendChild(WVJBIframe)
    // console.log('document.documentElement>>>>>', document.documentElement)

    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe)
    }, 0)
  }
}

function androidInit(callback) {
  console.log('桥接初始化函数androidInit>>>>>androidInit', window)
  console.log('window?.WebViewJavascriptBridge>>>>>androidInit', window?.WebViewJavascriptBridge)
  console.log('window?.WVJBCallbacks>>>>>androidInit', window?.WVJBCallbacks)
  if (window.WebViewJavascriptBridge) {
    callback(window.WebViewJavascriptBridge)
  } else {
    document.addEventListener(
      'WebViewJavascriptBridgeReady',
      function () {
        callback(window.WebViewJavascriptBridge)
      },
      false,
    )
  }
}

// 3. 统一调用桥接初始化
export function setupBridge(callback) {
  console.log('获取设备>>>>>>>>>>>>>>', u)
  console.log('判断设备isAndroid>>>>>>>>>>>>>>', isAndroid)
  console.log('判断设备isIOS>>>>>>>>>>>>>>', isIOS)
  if (isAndroid) {
    androidInit(callback)
  } else if (isIOS) {
    iosInit(callback)
  } else {
    callback(false)
  }
}
export function getBridge(): Promise<any> {
  return new Promise((resolve) => {
    setupBridge((bridge) => {
      resolve(bridge)
    })
  })
}
